module.exports = __webpack_public_path__ + "img/logo-casa-bco.f5aeb5d0.svg";